import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function CFSMaster() {
  // ─── Regex validators ───

  const isValidMobile = (val) => /^\d{9,11}$/.test(val);

  const addUploadsform = useRef(null); // only used for uploads
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // --- Add form state
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [port, setPort] = useState("");
  const [agent, setAgent] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [stateVal, setStateVal] = useState(""); // avoid 'state' conflict
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [landlineNumber, setLandlineNumber] = useState("");
  const [status, setStatus] = useState("ACTIVE");

  // --- Add form error states
  const [showNameError, setShowNameError] = useState(false);
  const [showCompanyError, setShowCompanyError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showPortError, setShowPortError] = useState(false);
  const [showAgentError, setShowAgentError] = useState(false);
  const [showAddressLine1Error, setShowAddressLine1Error] = useState(false);
  const [showAddressLine2Error, setShowAddressLine2Error] = useState(false);
  const [showCityError, setShowCityError] = useState(false);
  const [showStateError, setShowStateError] = useState(false);
  const [showPincodeError, setShowPincodeError] = useState(false);
  const [showContactPersonError, setShowContactPersonError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showMobileNumberError, setShowMobileNumberError] = useState(false);
  const [showLandlineNumberError, setShowLandlineNumberError] = useState(false);

  // --- Update form error states
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateCompanyError, setShowUpdateCompanyError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdatePortError, setShowUpdatePortError] = useState(false);
  const [showUpdateAgentError, setShowUpdateAgentError] = useState(false);
  const [showUpdateAddressLine1Error, setShowUpdateAddressLine1Error] =
    useState(false);
  const [showUpdateAddressLine2Error, setShowUpdateAddressLine2Error] =
    useState(false);
  const [showUpdateCityError, setShowUpdateCityError] = useState(false);
  const [showUpdateStateError, setShowUpdateStateError] = useState(false);
  const [showUpdatePincodeError, setShowUpdatePincodeError] = useState(false);
  const [showUpdateContactPersonError, setShowUpdateContactPersonError] =
    useState(false);
  const [showUpdateEmailError, setShowUpdateEmailError] = useState(false);
  const [showUpdateMobileNumberError, setShowUpdateMobileNumberError] =
    useState(false);
  const [showUpdateLandlineNumberError, setShowUpdateLandlineNumberError] =
    useState(false);

  // --- Update form state
  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateCompany, setUpdateCompany] = useState("");
  const [updatePort, setUpdatePort] = useState("");
  const [updateAgent, setUpdateAgent] = useState("");
  const [updateAddressLine1, setUpdateAddressLine1] = useState("");
  const [updateAddressLine2, setUpdateAddressLine2] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updatePincode, setUpdatePincode] = useState("");
  const [updateEmail, setUpdateEmail] = useState("");
  const [updateContactPerson, setUpdateContactPerson] = useState("");
  const [updateMobileNumber, setUpdateMobileNumber] = useState("");
  const [updateLandlineNumber, setUpdateLandlineNumber] = useState("");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");

  const [showUpdateCfsDetails, setShowUpdateCfsDetails] = useState(true);
  const [showUpdateUploadDetails, setShowUpdateUploadDetails] = useState(false);

  const [showDeleteUploadFilesLoader, setShowDeleteUploadFilesLoader] =
    useState(false);
  const [deleteCfsUploadModal, setDeleteCfsUploadModal] = useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState("");
  const [deleteUploadFileName, setDeleteUploadFileName] = useState("");

  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);
  const [uploadFileNames, setUploadFileNames] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  const [cfsUploads, setCfsUploads] = useState([]);
  const [cfsUploadDataPending, setCfsUploadDataPending] = useState(false);

  // Rest form
  const handleResetAddData = () => {
    setName("");
    setCompany("");
    setCountry("");
    setPort("");
    setAgent("");
    setAddressLine1("");
    setAddressLine2("");
    setCity("");
    setStateVal("");
    setPincode("");
    setEmail("");
    setContactPerson("");
    setMobileNumber("");
    setLandlineNumber("");
    setStatus("ACTIVE");
    setShowNameError(false);
    setShowCompanyError(false);
    setShowCountryError(false);
    setShowPortError(false);
    setShowAgentError(false);
    setShowAddressLine1Error(false);
    setShowAddressLine2Error(false);
    setShowCityError(false);
    setShowStateError(false);
    setShowPincodeError(false);
    setShowEmailError(false);
    setShowContactPersonError(false);
    setShowMobileNumberError(false);
    setShowLandlineNumberError(false);
    setShowValidationError(false);
    setIsValidationErrorVisible(false);
    setValidationErrorArray([]);
  };

  const handleResetUpdateData = () => {
    setUpdateId("");
    setUpdateName("");
    setUpdateCompany("");
    setUpdateCountry("");
    setUpdatePort("");
    setUpdateAgent("");
    setUpdateAddressLine1("");
    setUpdateAddressLine2("");
    setUpdateCity("");
    setUpdateState("");
    setUpdatePincode("");
    setUpdateEmail("");
    setUpdateContactPerson("");
    setUpdateMobileNumber("");
    setUpdateLandlineNumber("");
    setUpdateStatus("ACTIVE");
    setShowUpdateNameError(false);
    setShowUpdateCompanyError(false);
    setShowUpdateCountryError(false);
    setShowUpdatePortError(false);
    setShowUpdateAgentError(false);
    setShowUpdateAddressLine1Error(false);
    setShowUpdateAddressLine2Error(false);
    setShowUpdateCityError(false);
    setShowUpdateStateError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateEmailError(false);
    setShowUpdateContactPersonError(false);
    setShowUpdateMobileNumberError(false);
    setShowUpdateLandlineNumberError(false);
    setShowUpdateValidationError(false);
    setIsUpdateValidationErrorVisible(false);
    setUpdateValidationErrorArray([]);
    setShowUpdateCfsDetails(true);
    setShowUpdateUploadDetails(false);
  };
  // ADD validation summary states
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // UPDATE validation summary states
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // Real‑time error helpers
  const hasAnyAddError = () => {
    return (
      showNameError ||
      showCompanyError ||
      showCountryError ||
      showPortError ||
      showAgentError ||
      showAddressLine1Error ||
      showAddressLine2Error ||
      showCityError ||
      showStateError ||
      showPincodeError ||
      showEmailError ||
      showContactPersonError ||
      showMobileNumberError ||
      showLandlineNumberError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!name) errors.push("Name is required");
    if (!company) errors.push("Company is required");
    if (!country) errors.push("Country is required");
    if (!port) errors.push("Port is required");
    if (!agent) errors.push("Agent is required");
    if (!addressLine1) errors.push("Address Line 1 is required");
    if (!addressLine2) errors.push("Address Line 2 is required");
    if (!city) errors.push("City is required");
    if (!stateVal) errors.push("State is required");
    if (!pincode) errors.push("Pincode is required");
    if (!email) errors.push("Email is required");
    if (!contactPerson) errors.push("Contact Person is required");
    if (!mobileNumber) errors.push("Mobile Number is required");
    else if (!isValidMobile(mobileNumber))
      errors.push(
        "Mobile must be a valid 10-digit Indian number (starts with 6-9)",
      );
    if (!landlineNumber) errors.push("Landline Number is required");
    return errors;
  };

  // ========== Real‑time error helpers for UPDATE ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateNameError ||
      showUpdateCompanyError ||
      showUpdateCountryError ||
      showUpdatePortError ||
      showUpdateAgentError ||
      showUpdateAddressLine1Error ||
      showUpdateAddressLine2Error ||
      showUpdateCityError ||
      showUpdateStateError ||
      showUpdatePincodeError ||
      showUpdateEmailError ||
      showUpdateContactPersonError ||
      showUpdateMobileNumberError ||
      showUpdateLandlineNumberError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateName) errors.push("Name is required");
    if (!updateCompany) errors.push("Company is required");
    if (!updateCountry) errors.push("Country is required");
    if (!updatePort) errors.push("Port is required");
    if (!updateAgent) errors.push("Agent is required");
    if (!updateAddressLine1) errors.push("Address Line 1 is required");
    if (!updateAddressLine2) errors.push("Address Line 2 is required");
    if (!updateCity) errors.push("City is required");
    if (!updateState) errors.push("State is required");
    if (!updatePincode) errors.push("Pincode is required");
    if (!updateEmail) errors.push("Email is required");
    if (!updateContactPerson) errors.push("Contact Person is required");
    if (!updateMobileNumber) errors.push("Mobile Number is required");
    else if (!isValidMobile(updateMobileNumber))
      errors.push(
        "Mobile must be a valid 10-digit Indian number (starts with 6-9)",
      );
    if (!updateLandlineNumber) errors.push("Landline Number is required");
    return errors;
  };

  // Click handlers for validation tooltips
  const handleCheckValidationClick = () => {
    setValidationErrorArray(buildAddErrorMessages());
    setIsValidationErrorVisible(!isValidationErrorVisible);
  };

  const handleUpdateCheckValidationClick = () => {
    setUpdateValidationErrorArray(buildUpdateErrorMessages());
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);
  };

  // ---- API calls
  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getCFS = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/",
      );
      setTimeout(() => {
        if (response) {
          setData(response.data);
          setDataPending(false);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching cfs data! Try again.");
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const country_data = response.data;
      const sorted_data = country_data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      setCountryList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getPort = async (country) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/port/getportbycountry?country=" +
          country,
      );
      const port_data = response.data;
      const sorted_data = port_data.sort((a, b) => a.name - b.name);
      setPortList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getAgent = async (port) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/getagentbyport?port=" +
          port,
      );
      const agent_data = response.data;
      const sorted_data = agent_data.sort((a, b) => a.name - b.name);
      setAgentList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      if (role_permissions_array)
        setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggenInUser();
    getCFS();
    getCountry();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ---- Delete handlers ----
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/" + id + "/",
      );
      setShowDeleteModal(false);
      getCFS();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    getCFS();
    setShowDeleteLoader(false);
  };

  // ---- Add function  ----
  const addNewCFS = async (e) => {
    e.preventDefault();

    // Update error states based on current values
    setShowNameError(!name);
    setShowCompanyError(!company);
    setShowCountryError(!country);
    setShowPortError(!port);
    setShowAgentError(!agent);
    setShowAddressLine1Error(!addressLine1);
    setShowAddressLine2Error(!addressLine2);
    setShowCityError(!city);
    setShowStateError(!stateVal);
    setShowPincodeError(!pincode);
    setShowEmailError(!email);
    setShowContactPersonError(!contactPerson);
    setShowMobileNumberError(!mobileNumber || !isValidMobile(mobileNumber));
    setShowLandlineNumberError(!landlineNumber);
    setValidationErrorArray(buildAddErrorMessages());

    // If any required field is empty, stop
    if (
      !name ||
      !company ||
      !country ||
      !port ||
      !agent ||
      !addressLine1 ||
      !addressLine2 ||
      !city ||
      !stateVal ||
      !pincode ||
      !email ||
      !contactPerson ||
      !mobileNumber ||
      !isValidMobile(mobileNumber) ||
      !landlineNumber
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const data = {
      name,
      company_name: company,
      port,
      agent,
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      city,
      state: stateVal,
      country,
      pincode,
      email,
      contact_person: contactPerson,
      mobile_number: mobileNumber,
      landline_number: landlineNumber,
      status,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/",
        data,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("CFS Created Successfully");
        // Reset form
        setName("");
        setCompany("");
        setCountry("");
        setPort("");
        setAgent("");
        setAddressLine1("");
        setAddressLine2("");
        setCity("");
        setStateVal("");
        setPincode("");
        setEmail("");
        setContactPerson("");
        setMobileNumber("");
        setLandlineNumber("");
        setStatus("ACTIVE");
        setShowAddCanvas(false);
      }
    } catch (err) {
      toast.error("Error creating CFS");
    } finally {
      setShowAddLoader(false);
      getCFS();
    }
  };

  // ---- Update function
  const updateCFS = async (e) => {
    e.preventDefault();
    setShowUpdateNameError(!updateName);
    setShowUpdateCompanyError(!updateCompany);
    setShowUpdateCountryError(!updateCountry);
    setShowUpdatePortError(!updatePort);
    setShowUpdateAgentError(!updateAgent);
    setShowUpdateAddressLine1Error(!updateAddressLine1);
    setShowUpdateAddressLine2Error(!updateAddressLine2);
    setShowUpdateCityError(!updateCity);
    setShowUpdateStateError(!updateState);
    setShowUpdatePincodeError(!updatePincode);
    setShowUpdateEmailError(!updateEmail);
    setShowUpdateContactPersonError(!updateContactPerson);
    setShowUpdateMobileNumberError(
      !updateMobileNumber || !isValidMobile(updateMobileNumber),
    );
    setShowUpdateLandlineNumberError(!updateLandlineNumber);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateName ||
      !updateCompany ||
      !updateCountry ||
      !updatePort ||
      !updateAgent ||
      !updateAddressLine1 ||
      !updateAddressLine2 ||
      !updateCity ||
      !updateState ||
      !updatePincode ||
      !updateEmail ||
      !updateContactPerson ||
      !updateMobileNumber ||
      !updateLandlineNumber
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const id = updateId;
    const data = {
      name: updateName,
      company_name: updateCompany,
      port: updatePort,
      agent: updateAgent,
      address_line_1: updateAddressLine1,
      address_line_2: updateAddressLine2,
      city: updateCity,
      state: updateState,
      country: updateCountry,
      pincode: updatePincode,
      email: updateEmail,
      contact_person: updateContactPerson,
      mobile_number: updateMobileNumber,
      landline_number: updateLandlineNumber,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/" + id + "/",
        data,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("CFS updated Successfully");
        setShowUpdateCanvas(false);
      }
    } catch (err) {
      toast.error("Error updating CFS");
    } finally {
      setShowUpdateLoader(false);
      getCFS();
    }
  };

  // ---- Set record for update
  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateCompany(row.company_name);
    setUpdatePort(row.port);
    setUpdateAgent(row.agent);
    setUpdateAddressLine1(row.address_line_1);
    setUpdateAddressLine2(row.address_line_2);
    setUpdateCity(row.city);
    setUpdatePincode(row.pincode);
    setUpdateState(row.state);
    setUpdateCountry(row.country);
    setUpdateEmail(row.email);
    setUpdateContactPerson(row.contact_person);
    setUpdateMobileNumber(row.mobile_number);
    setUpdateLandlineNumber(row.landline_number);
    setUpdateStatus(row.status);
    getPort(row.country);
    getAgent(row.port);

    if (row.upload_urls?.length < 1) {
      setCfsUploads({});
      setCfsUploadDataPending(false);
    } else {
      setCfsUploads(row.upload_urls);
      setCfsUploadDataPending(false);
    }
  };

  // ---- Upload functions
  const uploadcolumns = [
    {
      name: "File Name",
      selector: (row) => row.filename,
      sortable: true,
    },
    {
      name: "Preview",
      selector: (row) => (
        <img
          className="img img-thumbnail"
          src={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          height={40}
          width={40}
          alt="preview"
        />
      ),
      sortable: true,
    },
    {
      name: "File Type",
      selector: (row) => row.filetype,
      sortable: true,
    },
    {
      name: "File Size",
      selector: (row) => row.filesize + " " + row.fileunit,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:cfs:delete") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0 mx-2"
              title="Preview"
            >
              <a
                className="text-decoration-none text-white"
                href={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-eye"></i>
              </a>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:cfs:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteUploadDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const handleUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    const names = [];
    fileArray.forEach((file) => names.push(file?.name));
    setUploadFileNames(names);
  };

  const addCfsUploads = async (e) => {
    e.preventDefault();
    setShowUploadFilesLoader(true);
    const id = updateId;
    const data = {
      id: id,
      upload: uploadFiles,
    };
    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/cfsuploads/",
      data,
      { headers: { "content-type": "multipart/form-data" } },
    );
    if (response.status === 200) {
      toast.success("Files Uploaded Successfully");
    }
    addUploadsform.current.uploads.value = [];
    setCfsUploads(response.data.upload_urls);
    setShowUploadFilesLoader(false);
  };

  const setDeleteUploadDetails = (row) => {
    setDeleteCfsUploadModal(true);
    setUploadFilesSerialNumber(row.serial_number);
    setDeleteUploadFileName(row.filename);
  };

  const deleteCfsUploads = async (e) => {
    e.preventDefault();
    setShowDeleteUploadFilesLoader(true);
    const id = updateId;
    const data = {
      id: id,
      serial_number: uploadFilesSerialNumber,
    };
    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL + "/master/cfs/deletecfsuploads/",
      data,
      { headers: { "content-type": "application/json" } },
    );
    if (response.status === 200) {
      toast.success("File Deleted Successfully");
      setCfsUploads(response.data.upload_urls);
    }
    setShowDeleteUploadFilesLoader(false);
    setDeleteCfsUploadModal(false);
  };

  // ---- DataTable columns
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Company",
      selector: (row) => row.company_name,
      sortable: true,
    },
    {
      name: "Port",
      selector: (row) => row.port_data?.name,
      sortable: true,
    },
    {
      name: "Agent",
      selector: (row) => row.agent_data?.name,
      sortable: true,
    },
    {
      name: "Address",
      width: "500px",
      selector: (row) =>
        row.address_line_1 +
        ", " +
        row.address_line_2 +
        ", " +
        row.city +
        ", " +
        row.state +
        " - " +
        row.pincode,
      sortable: true,
    },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            width={35}
            style={{ marginBottom: 5 }}
            alt={row.country_data?.long_name}
          />
          <br />
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Contact Person",
      selector: (row) => row.contact_person,
      sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row.mobile_number,
      sortable: true,
    },
    {
      name: "Landline Number",
      selector: (row) => row.landline_number,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:cfs:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => handleSetUpdateData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:cfs:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="CFSMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">CFS Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add CFS</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div
        className={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        data-bs-scroll="true"
        tabIndex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
              <Button
                className={`${showUpdateCfsDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateCfsDetails(true),
                  setShowUpdateUploadDetails(false),
                ]}
              >
                Details
              </Button>
              <Button
                className={`${showUpdateUploadDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateCfsDetails(false),
                  setShowUpdateUploadDetails(true),
                ]}
              >
                Uploads
              </Button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowUpdateCanvas(false);
                  handleResetUpdateData();
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {showUpdateCfsDetails && (
            <div>
              <form onSubmit={(e) => updateCFS(e)}>
                <div className="row">
                  {/* Name */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="name">
                      Name:
                      <span className="text-danger">
                        {showUpdateNameError ? "Name required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="name"
                      name="name"
                      placeholder="Enter Name"
                      value={updateName}
                      onChange={(e) => {
                        setUpdateName(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateNameError(false);
                        } else {
                          setShowUpdateNameError(true); // set error when empty
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateNameError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Company */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="company">
                      Company:
                      <span className="text-danger">
                        {showUpdateCompanyError ? "Company required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="company"
                      name="company"
                      placeholder="Enter Company Name"
                      value={updateCompany}
                      onChange={(e) => {
                        setUpdateCompany(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateCompanyError(false);
                        } else {
                          setShowUpdateCompanyError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateCompanyError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Country */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="country">
                      Country:
                      <span className="text-danger">
                        {showUpdateCountryError ? "Country required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="country"
                      value={updateCountry}
                      onChange={(e) => {
                        setUpdateCountry(e.target.value);
                        getPort(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateCountryError(false);
                        } else {
                          setShowUpdateCountryError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateCountryError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    >
                      <option value="">Select Country</option>
                      {countryList.map((c) => (
                        <option
                          key={c.id}
                          value={c.id}
                          selected={updateCountry === c.id}
                        >
                          {c.long_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Port */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="port">
                      Port:
                      <span className="text-danger">
                        {showUpdatePortError ? "Port required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="port"
                      value={updatePort}
                      onChange={(e) => {
                        setUpdatePort(e.target.value);
                        getAgent(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdatePortError(false);
                        } else {
                          setShowUpdatePortError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdatePortError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    >
                      <option value="">Select Port</option>
                      {portList.map((p) => (
                        <option
                          key={p.id}
                          value={p.id}
                          selected={updatePort === p.id}
                        >
                          {p.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Agent */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="agent">
                      Agent:
                      <span className="text-danger">
                        {showUpdateAgentError ? "Agent required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="agent"
                      value={updateAgent}
                      onChange={(e) => {
                        setUpdateAgent(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateAgentError(false);
                        } else {
                          setShowUpdateAgentError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateAgentError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    >
                      <option value="">Select Agent</option>
                      {agentList.map((a) => (
                        <option
                          key={a.id}
                          value={a.id}
                          selected={updateAgent === a.id}
                        >
                          {a.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Address Line 1 */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="address_line_1">
                      Address Line 1:
                      <span className="text-danger">
                        {showUpdateAddressLine1Error ? "Address required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="address_line_1"
                      name="address_line_1"
                      placeholder="Enter Address Line 1"
                      value={updateAddressLine1}
                      onChange={(e) => {
                        setUpdateAddressLine1(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateAddressLine1Error(false);
                        } else {
                          setShowUpdateAddressLine1Error(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateAddressLine1Error(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Address Line 2 */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="address_line_2">
                      Address Line 2:
                      <span className="text-danger">
                        {showUpdateAddressLine2Error ? "Address required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="address_line_2"
                      name="address_line_2"
                      placeholder="Enter Address Line 2"
                      value={updateAddressLine2}
                      onChange={(e) => {
                        setUpdateAddressLine2(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateAddressLine2Error(false);
                        } else {
                          setShowUpdateAddressLine2Error(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateAddressLine2Error(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* City */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="city">
                      City:
                      <span className="text-danger">
                        {showUpdateCityError ? "City required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="city"
                      name="city"
                      placeholder="Enter City"
                      value={updateCity}
                      onChange={(e) => {
                        setUpdateCity(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateCityError(false);
                        } else {
                          setShowUpdateCityError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateCityError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* State */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="state">
                      State:
                      <span className="text-danger">
                        {showUpdateStateError ? "State required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="state"
                      name="state"
                      placeholder="Enter State"
                      value={updateState}
                      onChange={(e) => {
                        setUpdateState(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateStateError(false);
                        } else {
                          setShowUpdateStateError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateStateError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Pincode */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="pincode">
                      Pincode:
                      <span className="text-danger">
                        {showUpdatePincodeError ? "Pincode required" : ""}
                      </span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="pincode"
                      name="pincode"
                      placeholder="Enter Pincode"
                      value={updatePincode}
                      onChange={(e) => {
                        setUpdatePincode(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdatePincodeError(false);
                        } else {
                          setShowUpdatePincodeError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdatePincodeError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Email */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="email">
                      Email:
                      <span className="text-danger">
                        {showUpdateEmailError ? "Email required" : ""}
                      </span>
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      id="email"
                      name="email"
                      placeholder="Enter Email"
                      value={updateEmail}
                      onChange={(e) => {
                        setUpdateEmail(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateEmailError(false);
                        } else {
                          setShowUpdateEmailError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateEmailError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Contact Person */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="contact_person">
                      Contact Person:{" "}
                      <span className="text-danger">
                        {showUpdateContactPersonError
                          ? "Contact Person required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="contact_person"
                      name="contact_person"
                      placeholder="Enter Contact Person"
                      value={updateContactPerson}
                      onChange={(e) => {
                        setUpdateContactPerson(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateContactPersonError(false);
                        } else {
                          setShowUpdateContactPersonError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateContactPersonError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Mobile Number */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="mobile_number">
                      Mobile Number:
                      <span className="text-danger">
                        {showUpdateMobileNumberError
                          ? "Mobile Number required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="mobile_number"
                      name="mobile_number"
                      placeholder="e.g. 9876543210"
                      value={updateMobileNumber}
                      onChange={(e) => {
                        setUpdateMobileNumber(e.target.value);

                        if (e.target.value !== "") {
                          setShowUpdateMobileNumberError(
                            !isValidMobile(e.target.value),
                          );
                        } else {
                          setShowUpdateMobileNumberError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateMobileNumberError(
                          !e.target.value || !isValidMobile(e.target.value),
                        );
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Landline Number */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="landline_number">
                      Landline Number:
                      <span className="text-danger">
                        {showUpdateLandlineNumberError
                          ? "Landline Number required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="landline_number"
                      name="landline_number"
                      placeholder="Enter Landline Number"
                      value={updateLandlineNumber}
                      onChange={(e) => {
                        setUpdateLandlineNumber(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateLandlineNumberError(false);
                        } else {
                          setShowUpdateLandlineNumberError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateLandlineNumberError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Status */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="status">Status: </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={updateStatus}
                      onChange={(e) => setUpdateStatus(e.target.value)}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>

                  {/* Submit button with validation */}
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
                  >
                    <Button
                      className="btn btn-inox-green border-0 canvas-button"
                      onClick={(e) => updateCFS(e)}
                      disabled={hasAnyUpdateError() || showUpdateLoader}
                    >
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-edit"></i>{" "}
                          <span className="mx-2">Update</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyUpdateError() || showUpdateValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleUpdateCheckValidationClick}
                          onMouseLeave={() =>
                            setIsUpdateValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {updateValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          )}

          {showUpdateUploadDetails && (
            <div>
              <form ref={addUploadsform} onSubmit={(e) => addCfsUploads(e)}>
                <div className="row">
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="uploads"
                      name="uploads"
                      accept="image/*, .pdf"
                      onChange={(e) => [
                        handleUploadsFileChange(e.target.files),
                        setUploadFiles(e.target.files),
                      ]}
                      multiple
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}
                  >
                    <Button
                      className="btn-inox-green border-0 btn-sm"
                      onClick={(e) => addCfsUploads(e)}
                      disabled={uploadFiles?.length < 1}
                    >
                      {showUploadFilesLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span className="px-1">Upload</span>
                      )}
                    </Button>
                  </div>
                </div>
                {uploadFiles?.length > 0 && (
                  <div className="row">
                    <div
                      className="col-12"
                      style={{ fontSize: 12, textAlign: "left" }}
                    >
                      Files:{" "}
                      {uploadFileNames.map((name, index) => (
                        <span key={index}>
                          {index !== 0 ? ",   " : ""}
                          <b>{index + 1}:</b> {name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </form>

              {cfsUploads?.length > 0 ? (
                <DataTable
                  columns={uploadcolumns}
                  data={cfsUploads}
                  progressPending={cfsUploadDataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">
                      No Uploads Found
                    </p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              ) : (
                <p style={{ marginTop: 100 }}>No Uploads Found</p>
              )}

              <Modal
                size="sm"
                show={deleteCfsUploadModal}
                onHide={() => setDeleteCfsUploadModal(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Delete{" "}
                    <span style={{ fontSize: 10 }}>
                      ({deleteUploadFileName})
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to delete this file?</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setDeleteCfsUploadModal(false)}
                  >
                    Close
                  </Button>
                  <Button variant="danger" onClick={(e) => deleteCfsUploads(e)}>
                    {showDeleteUploadFilesLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </div>
      </div>

      {/* ------------------------ Add Section ------------------- */}
      <div
        className={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowAddCanvas(false);
                  handleResetAddData();
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={(e) => addNewCFS(e)}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_name">
                  Name:
                  <span className="text-danger">
                    {showNameError ? "Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_name"
                  name="name"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value !== "") setShowNameError(false);
                    setShowValidationError(false); // hide global validation on change
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Company */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_company">
                  Company:
                  <span className="text-danger">
                    {showCompanyError ? "Company required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_company"
                  name="company"
                  placeholder="Enter Company Name"
                  value={company}
                  onChange={(e) => {
                    setCompany(e.target.value);
                    if (e.target.value !== "") setShowCompanyError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCompanyError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_country">
                  Country:
                  <span className="text-danger">
                    {showCountryError ? "Country required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  name="country"
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    getPort(e.target.value);
                    if (e.target.value !== "") setShowCountryError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCountryError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Country</option>
                  {countryList.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.long_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Port */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_port">
                  Port:
                  <span className="text-danger">
                    {showPortError ? "Port required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  name="port"
                  value={port}
                  onChange={(e) => {
                    setPort(e.target.value);
                    getAgent(e.target.value);
                    if (e.target.value !== "") setShowPortError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowPortError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Port</option>
                  {portList.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Agent */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_agent">
                  Agent:
                  <span className="text-danger">
                    {showAgentError ? "Agent required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  name="agent"
                  value={agent}
                  onChange={(e) => {
                    setAgent(e.target.value);
                    if (e.target.value !== "") setShowAgentError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAgentError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Agent</option>
                  {agentList.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Address Line 1 */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_address_line_1">
                  Address Line 1:
                  <span className="text-danger">
                    {showAddressLine1Error ? "Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_address_line_1"
                  name="address_line_1"
                  placeholder="Enter Address Line 1"
                  value={addressLine1}
                  onChange={(e) => {
                    setAddressLine1(e.target.value);
                    if (e.target.value !== "") setShowAddressLine1Error(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddressLine1Error(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Address Line 2 */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_address_line_2">
                  Address Line 2:
                  <span className="text-danger">
                    {showAddressLine2Error ? "Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_address_line_2"
                  name="address_line_2"
                  placeholder="Enter Address Line 2"
                  value={addressLine2}
                  onChange={(e) => {
                    setAddressLine2(e.target.value);
                    if (e.target.value !== "") setShowAddressLine2Error(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddressLine2Error(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* City */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_city">
                  City:
                  <span className="text-danger">
                    {showCityError ? "City required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_city"
                  name="city"
                  placeholder="Enter City"
                  value={city}
                  onChange={(e) => {
                    setCity(e.target.value);
                    if (e.target.value !== "") setShowCityError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCityError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* State */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_state">
                  State:
                  <span className="text-danger">
                    {showStateError ? "State required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_state"
                  name="state"
                  placeholder="Enter State"
                  value={stateVal}
                  onChange={(e) => {
                    setStateVal(e.target.value);
                    if (e.target.value !== "") setShowStateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowStateError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Pincode */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_pincode">
                  Pincode:
                  <span className="text-danger">
                    {showPincodeError ? "Pincode required" : ""}
                  </span>
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="add_pincode"
                  name="pincode"
                  placeholder="Enter Pincode"
                  value={pincode}
                  onChange={(e) => {
                    setPincode(e.target.value);
                    if (e.target.value !== "") setShowPincodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowPincodeError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Email */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_email">
                  Email:
                  <span className="text-danger">
                    {showEmailError ? "Email required" : ""}
                  </span>
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="add_email"
                  name="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (e.target.value !== "") setShowEmailError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value.trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    setShowEmailError(val === "" || !emailRegex.test(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Contact Person */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_contact_person">
                  Contact Person:
                  <span className="text-danger">
                    {showContactPersonError ? "Contact Person required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_contact_person"
                  name="contact_person"
                  placeholder="Enter Contact Person"
                  value={contactPerson}
                  onChange={(e) => {
                    setContactPerson(e.target.value);
                    if (e.target.value !== "") setShowContactPersonError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowContactPersonError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Mobile Number */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_mobile_number">
                  Mobile Number:
                  <span className="text-danger">
                    {showMobileNumberError
                      ? "Valid 10-digit mobile required (starts with 6-9)"
                      : ""}
                  </span>
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="add_mobile_number"
                  name="mobile_number"
                  placeholder="e.g. 9876543210"
                  value={mobileNumber}
                  onChange={(e) => {
                    setMobileNumber(e.target.value);

                    if (e.target.value !== "")
                      setShowMobileNumberError(!isValidMobile(e.target.value));
                    else setShowMobileNumberError(true);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowMobileNumberError(
                      !e.target.value || !isValidMobile(e.target.value),
                    );
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Landline Number */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_landline_number">
                  Landline Number:
                  <span className="text-danger">
                    {showLandlineNumberError ? "Landline Number required" : ""}
                  </span>
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="add_landline_number"
                  name="landline_number"
                  placeholder="Enter Landline Number"
                  value={landlineNumber}
                  onChange={(e) => {
                    setLandlineNumber(e.target.value);
                    if (e.target.value !== "")
                      setShowLandlineNumberError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowLandlineNumberError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status: </label>
                <select
                  className="form-select form-select-sm"
                  name="status"
                  value={status}
                  onChange={(e) => {
                    setStatus(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit button with validation */}
              <div
                className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <Button
                  className="btn btn-inox-green border-0 canvas-button"
                  onClick={(e) => addNewCFS(e)}
                  disabled={hasAnyAddError() || showAddLoader}
                >
                  {showAddLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="fa fa-plus"></i>{" "}
                      <span className="mx-2">Add</span>
                    </>
                  )}
                </Button>

                {(hasAnyAddError() || showValidationError) && (
                  <div className="error-tooltip-wrapper">
                    <Button
                      style={{
                        backgroundColor: "#C21E22",
                        border: "#f82e2e",
                      }}
                      title="Show Errors"
                      className="mx-2"
                      onClick={handleCheckValidationClick}
                      onMouseLeave={() => setIsValidationErrorVisible(false)}
                    >
                      <i className="fa fa-exclamation"></i>
                    </Button>
                    {isValidationErrorVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-4">
                          {validationErrorArray.map((error, index) => (
                            <li key={index} className="text-left small pb-0">
                              {error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CFSMaster;
